import React from 'react';
import {Trans} from 'react-i18next';
import { useTranslation } from 'react-i18next';
import './index.css';
import {API_ROOT} from "../../utils";

const WrongUser = (props) => {
    const { t } = useTranslation();
    return (
        <div className="wrong-user d-flex flex-column justify-content-center text-center">
            <h2 className="font-weight-light mb-4">{t("textWrongUserText6")}<strong className="text-nowrap">{t("textGscTitle")}</strong></h2>
            {
                props.userEmail
                ?
                    <p><Trans i18nKey="textWrongUserEmail"  values = {{userEmail:props.userEmail}} components={{a: <a href={`mailto:${props.userEmail}`}> </a>}} /> </p>
                :
                    <p>{t("textWrongUserText3")}</p>
            }
            <p>{t("textWrongUserText4")}</p>
            <p>
                <a className="accountchooser" href={`${API_ROOT}/account/switchuser`}>
                    <img src="https://www.gmailsharedcontacts.com/wp-content/uploads/2020/01/g-suite-icon.png" alt="G"/> {t("textSignIn")}
                </a>
            </p>

        </div>
    );
};

export default WrongUser;